import React, { useState } from "react";
import logo from "../assets/logo-circle-only.png";

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const fullText = ` "True quality is never rushed. It is cultivated. Our journey began
    with a deep respect for nature and an uncompromising belief that
    purity is a discipline, not a claim. As founders, we set out to
    create organic dehydrated powders that reflect the highest standards
    of integrity — from soil to shipment. Each ingredient we export is
    thoughtfully sourced from trusted growers, processed with precision
    to preserve its natural essence, and validated through rigorous
    quality controls. We favor craftsmanship over scale, and consistency
    over compromise. What we offer the world is not merely a product,
    but a promise — of authenticity, traceability, and quiet excellence
    in every consignment. As we grow across markets, our philosophy
    remains constant: elevated nutrition, responsibly delivered."`;

  // Determine how many characters to show before "Read More"
  const previewText = fullText.slice(0, 385) + "...";

  return (
    <section id="about" className="py-16 md:py-24 bg-slate-50 scroll-mt-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Why Choose Us & Core Promises */}
          <div className="space-y-8">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-primary uppercase">
              Why Choose Us?
            </h2>
            <div className="space-y-4">
              <h4 className="font-display font-bold text-accent uppercase tracking-widest">
                Our Core Promises
              </h4>
              <ul className="space-y-4">
                {[
                  "Uncompromising Quality Control",
                  "Direct Farm-to-Export Sourcing",
                  "Sustainable Dehydration Technology",
                  "Transparent Global Logistics",
                ].map((promise, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm border-l-4 border-accent"
                  >
                    <span className="font-bold text-primary">{promise}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Founder Note */}
          <div className="bg-primary p-10 rounded-3xl text-white shadow-2xl relative">
            <h3 className="font-display text-2xl font-bold text-accent mb-6 uppercase">
              Founder's Note
            </h3>

            <div className="mb-6">
              <p className="italic text-white/80 leading-relaxed inline">
                {isExpanded ? fullText : previewText}
              </p>
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="ml-2 text-accent font-bold hover:underline focus:outline-none text-sm uppercase tracking-wider"
              >
                {isExpanded ? "Show Less" : "Read More"}
              </button>
            </div>

            <div className="flex items-center gap-4 border-t border-white/10 pt-6">
              <div className="h-12 w-12 rounded-full flex items-center justify-center overflow-hidden">
                <img
                  src={logo}
                  alt="Indo Globus Logo"
                  className="h-full w-full object-contain"
                />
              </div>
              <div>
                <p className="font-bold text-accent">
                  R Sai Abhyuday & S Chandra Kanth
                </p>
                <p className="text-[10px] uppercase tracking-widest text-white/50">
                  Founders, IndoGlobus
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
